import { AlertTriangle } from 'lucide-react';

export function ChatTopHeader({ projectAssigned, onLinkProject }) {
    if (projectAssigned) return null;

    return (
        <div className="w-full bg-yellow-900/40 border-b border-yellow-700 text-yellow-200">
            <div className=" mx-auto px-4 py-2 flex items-center justify-between">
                <div className="flex items-center gap-2 text-base">
                    <AlertTriangle size={16} />
                    <span className="text-white text-sm">
                        <strong className="text-yellow-200 text-base">Unassigned Chat</strong> — Link this chat to a project to start
                        working on permits
                    </span>
                </div>

                <button
                    onClick={onLinkProject}
                    className="px-3 py-1.5 rounded-md text-sm font-medium bg-yellow-500 text-black hover:bg-yellow-400 transition"
                >
                    Link to Project
                </button>
            </div>
        </div>
    );
}
